import React from 'react';

import ButtonComponent from './redesign/buttonComponent/buttonComponent';
import WarningBell from '../../../assets/svgComponents/WarningBell';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './customerNotificationComponent.css';

const CustomerNotificationComponent = ({
  showCloseIcon = true,
  acceptBtnTxt,
  closeBtnTxt,
  rejectBtnTxt,
  notificationTxt,
  notificationType,
  acceptBtnFunc,
  closeBtnFunc,
  rejectBtnFunc,
}) => {
  const isWarningPopup =
    notificationType === VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING;
  return (
    <div className="et-customer-notification-container">
      <div className="et-customer-notification-content-wrap">
        {isWarningPopup && (
          <div>
            <WarningBell />
          </div>
        )}
        <div
          className={`et-customer-notification-msg ${isWarningPopup ? 'et-customer-notification-msg-warn' : ''}`}>
          {notificationTxt}
        </div>
        <div className="et-customer-notification-btns-wrap">
          {!rejectBtnTxt && !acceptBtnTxt && !closeBtnTxt && showCloseIcon ? (
            <div className="et-customer-notification-btn">
              <ButtonComponent
                type="primary-outlined"
                text={'OK'}
                onClick={closeBtnFunc}
              />
            </div>
          ) : null}

          {rejectBtnTxt ? (
            <div
              className={`et-customer-notification-btn ${
                isWarningPopup
                  ? 'et-customer-notification-reject-btn-warn'
                  : 'et-customer-notification-reject-btn'
              }`}>
              <ButtonComponent
                type="primary"
                text={rejectBtnTxt}
                onClick={rejectBtnFunc}
              />
            </div>
          ) : null}
          {closeBtnTxt ? (
            <div className="et-customer-notification-btn et-customer-notification-close-btn">
              <ButtonComponent
                type="primary-outlined"
                text={closeBtnTxt}
                onClick={closeBtnFunc}
              />
            </div>
          ) : null}
          {acceptBtnTxt ? (
            <div className="et-customer-notification-btn et-customer-notification-accept-btn">
              <ButtonComponent
                type="primary"
                text={acceptBtnTxt}
                onClick={acceptBtnFunc}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CustomerNotificationComponent;
